import React from "react";

const UpWork = () => {
  return (
    <svg
      className={
        "h-[25px] w-[25px] md:h-[30px] md:w-[30px] lg:h-[35px] lg:w-[35px] xl:h-[43px] xl:w-[43px]"
      }
      xmlns="http://www.w3.org/2000/svg"
      width="43"
      height="43"
      fill="none"
      viewBox="0 0 43 43"
    >
      <path
        fill="#16303A"
        d="M21.166 42.333c11.69 0 21.167-9.477 21.167-21.166C42.333 9.476 32.856 0 21.167 0 9.476 0 0 9.477 0 21.166c0 11.69 9.477 21.167 21.166 21.167z"
      ></path>
      <path
        fill="#fff"
        d="M28.561 15.525c-2.539 0-4.51 1.647-5.31 4.362-1.22-1.832-2.148-4.032-2.687-5.886h-2.736v7.105a2.55 2.55 0 01-2.547 2.545 2.549 2.549 0 01-2.545-2.545V14H10v7.105c0 2.911 2.371 5.298 5.282 5.298 2.913 0 5.283-2.387 5.283-5.298v-1.189c.529 1.106 1.182 2.228 1.974 3.219L20.865 31h2.797l1.213-5.705c1.063.679 2.285 1.109 3.686 1.109 3 0 5.439-2.45 5.439-5.445a5.441 5.441 0 00-5.439-5.434zm0 8.132c-1.102 0-2.135-.467-3.074-1.227l.228-1.074.008-.042c.207-1.143.849-3.058 2.839-3.058a2.703 2.703 0 012.703 2.7 2.706 2.706 0 01-2.704 2.701z"
      ></path>
    </svg>
  );
};

export default UpWork;
